module.exports = __webpack_public_path__ + "img/157.0ec33944.jpg";